import React from 'react';
import ContentLoader from 'react-content-loader';

const HeroBackgroundSkeleton = () => {
  return (
    <div className="overflow-hidden w-full absolute top-0 left-0 hidden md:block">
      <ContentLoader
        backgroundColor="var(--neutral-40)"
        foregroundColor="var(--neutral-200)"
        className="w-full min-h-[200px] sm:min-h-[460px] bg-center bg-cover blur-[20px] scale-125"
      >
        <rect x="0" y="0" height="100%" width="100%" />
      </ContentLoader>
    </div>
  );
};

export default HeroBackgroundSkeleton;
